import { ProjectListPage } from '@/pages/projects/ProjectListPage';
import { ROUTES } from '@/constants/routes';

export default function CrmProjectsPage() {
  return (
    <ProjectListPage
      source="crm"
      backRoute={ROUTES.CRM}
      detailRoutePrefix={ROUTES.CRM_PROJECTS}
      titleKey="crm.projects"
    />
  );
}
